<template>
    <div :class="isMobile ? 'productDetail-m' : 'productDetail'">
      <el-breadcrumb separator="/" class="bread">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/news' }">新闻动态</el-breadcrumb-item>
        <el-breadcrumb-item>新闻详情</el-breadcrumb-item>
      </el-breadcrumb>
      <el-row class="part" v-if="isShow">
        <el-col :span="isMobile ? 24 : 8" class="imgPart">
          <img class="bigImg" :src="require(`./../../assets/news/${thisObj.imgUrl}`)" />
        </el-col>
        <el-col :span="isMobile ? 22 : 14" :offset="isMobile ? 0 : 2">
          <div>
            <div class="title">{{thisObj.title}}</div>
            <div class="subtitle">{{ thisObj.text }}</div>
            <div class="detail">
              <li  class="detail-one" v-for="(item, index) in thisObj.detail" :key="index">{{ item }}</li>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </template>
  
  <script>
  import arrJson from "../../utils/arrJson"
  export default {
    name: 'NewsDetail',
    data() {
      return {
        isMobile: window.innerWidth < 780,
        id: null,
        isShow: false,
        thisObj: {}
      }
    },
    mounted() {
      this.getDetail()
      window.addEventListener("resize", this.initFunc)
    },
    destroyed() {
      window.removeEventListener("resize", this.initFunc)
    },
    methods: {
      getDetail() {
        let parentId = null
        const pathList = this.$router.currentRoute.path.split("/") // 取url上的id
        this.id = pathList[pathList.length-1]
        const index = arrJson.lastNews.findIndex(item => item.id == this.id)
        this.thisObj = arrJson.lastNews[index]
        this.isShow = true
      },
      initFunc() {
        this.isMobile = window.innerWidth < 780
      }
    },
    props: {
      msg: String
    }
  }
  </script>
  
  
  <style scoped lang="less">
    /deep/ .el-breadcrumb__inner.is-link{
      font-weight: normal;
    }
    .productDetail{
      max-width: 1100px;
      margin: 0 auto 60px;
      .bread{
        line-height: 50px;
        margin-top: 20px;
      }
      .part{
        text-align: left;
        .imgPart{
          background: #d6dde8;
          text-align: center;
        }
        .bigImg{
          max-width: 100%;
          max-height: 400px;
          display: block;
          margin: 0 auto;
        }
        .title{
          font-size: 26px;
          line-height: 40px;
        }
        .subtitle{
          font-size: 16px;
          color: #244c6e;
          font-weight: bold;
          line-height: 40px;
          margin-top: 20px;
        }
        .text{
          font-size: 16px;
          line-height: 30px;
          text-align: left;
          color: #6f6f6f;
          text-indent: 32px;
        }
        .detail{
          margin: 30px 0;
          .detail-one{
            line-height: 40px;
          }
        }
        .toPdf{
          margin: 20px 0;
          display: block;
          color: #0089fe;
        }
      }
    }
    .productDetail-m{
      margin: 0 0.4rem 1rem;
      /deep/ .el-breadcrumb{
        font-size: 0.4rem;
      }
      .bread{
        line-height: 1.2rem;
      }
      .part{
        text-align: left;
        .imgPart{
          padding: 0.1rem;
          background: #d6dde8;
          text-align: center;
        }
        .bigImg{
          max-width: 90%;
          max-height: 10rem;
          display: block;
          margin: 0 auto;
        }
        .title{
          font-size: 0.46rem;
          line-height: 0.9rem;
          margin-top: 0.4rem;
        }
        .subtitle{
          font-size: 0.38rem;
          color: #244c6e;
          font-weight: bold;
          line-height: 0.6rem;
          margin-top: 0.6rem;
        }
        .text{
          font-size: 0.38rem;
          line-height: 0.7rem;
          text-align: left;
          color: #6f6f6f;
          text-indent: 0.7rem;
        }
        .detail{
          margin: 0.6rem 0;
          font-size: 0.34rem;
          .detail-one{
            line-height: 0.8rem;
          }
        }
        .toPdf{
          margin: 0.46rem 0;
          display: block;
          color: #0089fe;
          font-size: 0.4rem;
        }
      }
    }
  
  
  </style>